/*global ViewController, scriptLoader, WebView, Office, WebdavController*/
var docOutlookPluginController = new ViewController(
    {
        directory: "views/public",
        name: "outlookPlugin",
        route: "outlook-plugin",
        container: "main",
    }
);

var OFFICE_JS_LIB = {
    name: "office-lib-js",
    type: "js",
    cdn: "https://appsforoffice.microsoft.com/lib/1.1/hosted/office.js",
} ;

/*
//create page PUBLIC with auth auto from email get from
https://docs.microsoft.com/fr-fr/javascript/api/outlook/office.userprofile?view=outlook-js-preview

sso
https://github.com/OfficeDev/Outlook-Add-in-SSO
https://docs.microsoft.com/fr-fr/office/dev/add-ins/reference/manifest/webapplicationinfo

https://github.com/gscales/gscales.github.io/blob/master/OWAExportAsEML/MessageRead.js
*/



function b64toBlob(b64Data, contentType, sliceSize) {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;
  
    var byteCharacters = atob(b64Data);
    var byteArrays = [];
  
    for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      var slice = byteCharacters.slice(offset, offset + sliceSize);
  
      var byteNumbers = new Array(slice.length);
      for (var i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      var byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
  
    var blob = new Blob(byteArrays, {type: contentType});
    return blob;
}

//handle the opening parameters
docOutlookPluginController.prepareDataOnEnter = function(data, callback){
    // load OFFICE JS API if not loaded
    scriptLoader.load(OFFICE_JS_LIB, function(err, result){
        if(err){ return callback(err) ;}
        Office.onReady(function(info){

             //check token
            var authToken = localStorage.getItem("auth_token") ;
            if(!authToken){
                //no token yet
                return callback(null, {
                    email: Office.context.mailbox.userProfile.emailAddress,
                    noToken: true
                });
            }else{
                //check the token is OK
                this.api.public.getTokenStatus(authToken, function(err, checkToken){
                    if(err){ return callback(err) ; }
                    if(checkToken === "ACTIVE"){
                        //load data normal
                        this.loadData({}, callback) ;
                    }else{
                        if(checkToken === "NOT_ACTIVE"){
                            setTimeout(function(){
                                this.view.longTask(function(done){
                                    this.refresh(done) ;
                                }.bind(this)) ;
                            }.bind(this), 20000) ;
                        }
                        return callback(null, {
                            tokenError: checkToken
                        }) ;
                    }
                }.bind(this)) ;
            }
        }.bind(this));
    }.bind(this)) ;
} ;

docOutlookPluginController.loadData = function(data, callback){
    if(!this.libLoaded){
        this.doLogin(function(err){
            if(err){ return callback(err) ; }
            this.libLoaded = true ;
            this.loadData(data, callback) ;
        }.bind(this));
        return;
    }

    var searches = {} ;

    searches.iz_doc_space = { search: {active: true} } ;
    searches.iz_doc_basket = { search: {active: true} } ;
    this.api.db.multiread(searches, function(err, reads){
        if(err){ 
            if(err === "NOT_CONNECTED"){
                this.doLogin(function(err){
                    if(err){ return callback(err) ; }
                    this.loadData(data, callback) ;
                }.bind(this));
                return ;
            }
            return callback(err) ; 
        }

        if(!data.criterias){
            data.criterias = [{}] ;
        }
        data.spaces = reads.iz_doc_space ;
        data.baskets = reads.iz_doc_basket ;
        // data.isCompose = true ;
        data.isCompose =   Office.context.mailbox.item &&  Office.context.mailbox.item.addFileAttachmentFromBase64Async ;
        callback(null, data) ;
    }.bind(this)) ;
};

docOutlookPluginController.doLogin = function(callback){
    this.api.auth.userToken("oauth", localStorage.getItem("auth_token") , "plugin_outlook", function(err, user){
        if(err){ return callback(err) ; }

        var modulesToLoad = ["doc"] ;

        modulesToLoad = modulesToLoad.filter(function(m){
            return user.rights["group_iz_"+m+"_module_user"] ;
        }) ;

        var langs = ["fr", "fr-FR", "en", "en-US", "en-GB", "vi", "vi-VN"] ; 
        
        //load the needed module bundles
        scriptLoader.load(modulesToLoad.map(function(m){
            var jsBundle = { 
                name: "izee-module-"+m,
                type: "js",
                localPath: m+"_bundle.js"
            } ;
            if(m.indexOf("/") !== -1) {
                return [jsBundle].concat(langs.map(function(lang){
                    return {
                        name: "izee-module-"+m+"-tr-"+lang,
                        type: "json",
                        localPath: m.substring(0, m.indexOf("/"))+"/locales/"+lang+".json"
                    } ;
                })) ;
            } else{
                return jsBundle ;
            }
        }), function(err, results){
            if(err){ return callback(err) ;}

            modulesToLoad.forEach(function(m, i){
                if(m.indexOf("/") !== -1) {
                    langs.forEach(function(l, y){
                        var bundle = results[i][1+y] ;
                        WebView.i18n.addBundle(l, bundle) ;
                    }) ;
                }
            }) ;

            callback() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


docOutlookPluginController.onOpenPrefs = function(){
    Office.context.ui.openBrowserWindow(window.location.href.replace(window.location.hash, "#!dashboard~user-prefs$tokens"));
};

docOutlookPluginController.onBackToSpaces = function(ev){
    delete this.data.space_id ;
    delete this.data.space ;
    this.view.longTask(function(done){
        this.loadData(this.data, function(err){
            if(err){ return done(err) ; }
            this.view.render() ;
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
};
docOutlookPluginController.onOpenSpace = function(ev){
    this.data.space_id = ev.data.data.id ;
    this.data.space = ev.data.data ;
    this.data.criterias[0].space_id = ev.data.data.id ;
    this.data.docResults = [] ; ;
    this.view.longTask(function(done){
        this.loadData(this.data, function(err){
            if(err){ return done(err) ; }
            this.view.render() ;
            this.view.setReadOnly(false);
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;


docOutlookPluginController.onSearchDoc = function(ev){
    this.view.updateData() ;
    var criterias = ev.data.data ;
    this.view.longTask(function(done){
        var searchCriterias = [] ;
        Object.keys(criterias).forEach(function(k){
            var value = ev.data.data[k] ;
            if(value !== null && value !== undefined && value !== ""){
                var searchCol = {} ;
                if(/__start$/.test(k)){
                    searchCol[k] = { ope: ">=", value: value};
                }else if(/__end$/.test(k)){
                    searchCol[k] = { ope: "<=", value: value};
                }else{
                    if(typeof(value) === "string"){
                        value = "%"+value+"%" ;
                    }
                    searchCol[k] = value;
                }
                searchCriterias.push(searchCol) ;
            }
        }.bind(this)) ;
        searchCriterias.push({ space_id: this.data.space_id }) ;
        searchCriterias.push({ active: true }) ;
        searchCriterias.push({ is_last_revision: true }) ;
        searchCriterias.push({ usage: "doc" }) ;
        this.api.db.multiread({
            iz_doc: { 
                search: {$and: searchCriterias}, 
                limit: 1000, orderBy: "reference",
                joinFetch: [
                    {otherTable: "ir_attachment", name:"attach", thisField: "id", 
                        otherField: "res_id", joinSearch: {res_model : "iz.doc"}}
                ]
            }
        }, function(err, reads){
            if(err){ return done(err) ; }
            this.data.docsResults = reads.iz_doc ;
            this.view.render() ; 
            done() ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

docOutlookPluginController.onRequestTokenAgain = function(){
    localStorage.removeItem("auth_token") ;
    this.refresh() ;
} ;
docOutlookPluginController.onRequestToken = function(){
    this.view.updateData() ;
    this.view.longTask(function(done){
        this.api.public.requestTokenAccess(this.data.email, "plugin_outlook", function(err, token){
            if(err){ 
                if(err === "NOT_FOUND"){
                    err = WebView.tr("plugin.emailNotFound") ;
                }
                return done(err) ; 
            }
            localStorage.setItem("auth_token", token) ;
            this.refresh(done) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

docOutlookPluginController.onOpenUpload = function(ev){
    if(ev.data.basket_id){
        this.view.longTask(function(done){

            var file = ev.data.file;
            var records = [] ;
            var docRecord = {
                usage: "basket",
                basket_id: ev.data.basket_id,
                name: file.name,
            } ;

            records.push({
                table: "iz_doc",
                action: "insert",
                record: docRecord
            }) ;

            this.api.db.transactionalChanges(records, function(err, results){
                if(err){ return done(err) ;}
                var doc = results[0].record ;
                var binaryRecord = {
                    res_model: "iz.doc", 
                    res_id: doc.id, 
                    mimetype: file.type,
                    datas_fname : file.name,
                    name: file.name,
                    res_name: file.name
                };
                
                this.api.api.saveBinary(
                    file,
                    binaryRecord, function(err){
                        if(err){ return done(err) ; }
                        WebView.info(WebView.tr("docBasket.docAdd")) ;
                        done() ;
                    }) ;
            }.bind(this)) ;
        }.bind(this)) ;
    }else{
        window.app.context.controllers.docController._createDocument(ev.data) ;
    }
} ;

function formatMail(mail){
    if (mail.displayName) {
        return encode(mail.displayName)+" <"+mail.emailAddress+">" ;
    } else {
        return mail.emailAddress ;
    }
}


var stringFromCharCode = String.fromCharCode;
var decode = function(input) {
    return input
        // https://tools.ietf.org/html/rfc2045#section-6.7, rule 3:
        // “Therefore, when decoding a `Quoted-Printable` body, any trailing white
        // space on a line must be deleted, as it will necessarily have been added
        // by intermediate transport agents.”
        .replace(/[\t\x20]$/gm, '')
        // Remove hard line breaks preceded by `=`. Proper `Quoted-Printable`-
        // encoded data only contains CRLF line  endings, but for compatibility
        // reasons we support separate CR and LF too.
        .replace(/=(?:\r\n?|\n|$)/g, '')
        // Decode escape sequences of the form `=XX` where `XX` is any
        // combination of two hexidecimal digits. For optimal compatibility,
        // lowercase hexadecimal digits are supported as well. See
        // https://tools.ietf.org/html/rfc2045#section-6.7, note 1.
        .replace(/=([a-fA-F0-9]{2})/g, function($0, $1) {
            var codePoint = parseInt($1, 16);
            return stringFromCharCode(codePoint);
        });
};

var handleTrailingCharacters = function(string) {
    return string
        .replace(/\x20$/, '=20') // Handle trailing space.
        .replace(/\t$/, '=09') ; // Handle trailing tab.
};
var regexUnsafeSymbols = /[\0-\b\n-\x1F=\x7F-\uD7FF\uDC00-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF]/g;
var encode = function(string) {
    // Encode symbols that are definitely unsafe (i.e. unsafe in any context).
    var encoded = string.replace(regexUnsafeSymbols, function(symbol) {
        if (symbol > '\xFF') {
            throw RangeError(
                '`quotedPrintable.encode()` expects extended ASCII input only. ' +
                'Don\u2019t forget to encode the input first using a character ' +
                'encoding like UTF-8.'
            );
        }
        var codePoint = symbol.charCodeAt(0);
        var hexadecimal = codePoint.toString(16).toUpperCase();
        return '=' + ('0' + hexadecimal).slice(-2);
    });

    // Limit lines to 76 characters (not counting the CRLF line endings).
    var lines = encoded.split(/\r\n?|\n/g);
    var lineIndex = -1;
    var lineCount = lines.length;
    var result = [];
    while (++lineIndex < lineCount) {
        var line = lines[lineIndex];
        // Leave room for the trailing `=` for soft line breaks.
        var LINE_LENGTH = 75;
        var index = 0;
        var length = line.length;
        while (index < length) {
            var buffer = encoded.slice(index, index + LINE_LENGTH);
            // If this line ends with `=`, optionally followed by a single uppercase
            // hexadecimal digit, we broke an escape sequence in half. Fix it by
            // moving these characters to the next line.
            if (/=$/.test(buffer)) {
                buffer = buffer.slice(0, LINE_LENGTH - 1);
                index += LINE_LENGTH - 1;
            } else if (/=[A-F0-9]$/.test(buffer)) {
                buffer = buffer.slice(0, LINE_LENGTH - 2);
                index += LINE_LENGTH - 2;
            } else {
                index += LINE_LENGTH;
            }
            result.push(buffer);
        }
    }

    // Encode space and tab characters at the end of encoded lines. Note that
    // with the current implementation, this can only occur at the very end of
    // the encoded string — every other line ends with `=` anyway.
    var lastLineLength = buffer.length;
    if (/[\t\x20]$/.test(buffer)) {
        // There’s a space or a tab at the end of the last encoded line. Remove
        // this line from the `result` array, as it needs to change.
        result.pop();
        if (lastLineLength + 2 <= LINE_LENGTH + 1) {
            // It’s possible to encode the character without exceeding the line
            // length limit.
            result.push(
                handleTrailingCharacters(buffer)
            );
        } else {
            // It’s not possible to encode the character without exceeding the line
            // length limit. Remvoe the character from the line, and insert a new
            // line that contains only the encoded character.
            result.push(
                buffer.slice(0, lastLineLength - 1),
                handleTrailingCharacters(
                    buffer.slice(lastLineLength - 1, lastLineLength)
                )
            );
        }
    }

    // `Quoted-Printable` uses CRLF.
    return "=?iso-8859-1?Q?"+result.join('=\r\n')+"?=";
};

docOutlookPluginController.onPushEmail = function(ev){

    this.view.longTask(function(done){
        var selectedItem = Office.context.mailbox.item ;
    
        selectedItem.body.getAsync("html", function(body){
            var boundary = WebView.uuid() ;
        
            var eml = [];
            if(selectedItem.from){
                eml.push("From: "+formatMail(selectedItem.from));
            }
            if(selectedItem.to && selectedItem.to.length>0){
                eml.push("To: "+selectedItem.to.map(function(to){
                    return formatMail(to) ;
                }).join(", "));
            }
            if(selectedItem.cc && selectedItem.cc.length>0){
                eml.push("Cc: "+selectedItem.cc.map(function(cc){
                    return formatMail(cc) ;
                }).join(", "));
            }
            if(selectedItem.subject){
                eml.push("Subject: "+selectedItem.subject);
            }
            eml.push("Content-Type: multipart/mixed; boundary=--"+boundary);
            eml.push("");
            eml.push("----"+boundary);
            eml.push("Content-Type: text/html; charset=UTF-8");
            eml.push("");
            eml.push(body.value);
    
            var calls = [function(cb){ cb() ; }] ;
            selectedItem.attachments.forEach(function(attachment){
                calls.push(function(cb){
                    selectedItem.getAttachmentContentAsync(attachment.id, function(result){
                        eml.push("----"+boundary);
                        eml.push("Content-Type: "+attachment.contentType+"; name="+attachment.name);
                        eml.push("Content-Transfer-Encoding: base64");
                        eml.push("Content-Disposition: "+(attachment.isInline?"inline":"attachment"));
                        eml.push("");
                        eml.push(result.value.content);
                        cb() ;
                    }.bind(this)) ;
                }.bind(this)) ;
            }.bind(this)) ;
    
            WebView._asyncSeries(calls, function(err){
                if(err){ return done(err) ; }
                done() ;
                var filename = selectedItem.subject+".eml" ;
                var emlString = eml.join("\r\n") ;
                var file = new Blob([emlString], filename, {
                    type: "message/rfc822",
                }) ;
                file.name = filename;
                window.app.context.controllers.docController._createDocument({
                    file: file,
                    space_id: ev.data.data.id
                }) ;
            }) ;
        }.bind(this)) ;
    }.bind(this)) ;
} ;

function arrayBufferToBase64(buffer) {
    let binary = '';
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

docOutlookPluginController.onAddDocToAttach = function(ev){
    var selectedItem = Office.context.mailbox.item ;
    var doc = ev.data.data ;
    this.view.longTask(function(done){
        this.api.doc.oneTimePublicUrl(doc.attach.id, doc.attach.datas_fname, function(err, token){
            if(err){ return done(err) ;}
            fetch(this.api.options.serverUrl+"/api/public/downloadOneTime?dbName="+this.api.db.schema.__dbName+"&token="+token).then(response=>{
                return response.arrayBuffer() ;
            }).then(buffer=>{
                let base64 = arrayBufferToBase64(buffer) ;
                selectedItem.addFileAttachmentFromBase64Async(base64, 
                    doc.attach.datas_fname,
                    {}, ()=>{
                        done() ;
                    }) ;
            }) ;
        }.bind(this)) ;
    }.bind(this)) ;
};

module.exports = docOutlookPluginController ;